var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandinglogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 66,
    viewBox: "0 0 131 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3005_40560)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8827 52.1206C26.232 52.5765 26.4068 53.1431 26.4068 53.8195C26.4068 54.7525 26.0469 55.4728 25.3287 55.9803C24.6099 56.4877 23.5628 56.7411 22.1869 56.7411H16.8279V45.9777H21.8791C23.152 45.9777 24.1323 46.2259 24.8204 46.7232C25.5082 47.2205 25.8522 47.9045 25.8522 48.7759C25.8522 49.3087 25.7288 49.7807 25.4826 50.1903C25.2365 50.6007 24.8975 50.9188 24.4661 51.1436C25.0616 51.3389 25.5341 51.6646 25.8827 52.1206ZM18.8297 47.5458V50.5137H21.6635C22.3613 50.5137 22.8975 50.388 23.2729 50.1371C23.6475 49.8856 23.8345 49.5191 23.8345 49.0377C23.8345 48.5454 23.6475 48.1739 23.2729 47.9225C22.8975 47.6716 22.3613 47.5458 21.6635 47.5458H18.8297ZM24.3892 53.6195C24.3892 52.5842 23.6138 52.0667 22.0637 52.0667H18.8297V55.173H22.0637C23.6138 55.173 24.3892 54.6554 24.3892 53.6195Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4801 55.0652V56.7412H30.3953V45.9778H38.2644V47.6538H32.3971V50.4523H37.6022V52.0972H32.3971V55.0652H38.4801Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5614 45.9778H44.5631V55.0499H50.1997V56.7412H42.5614V45.9778Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6339 45.9778H55.6357V55.0499H61.2722V56.7412H53.6339V45.9778Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.286 45.9778V56.7412H72.2837V52.1283H66.709V56.7412H64.7071V45.9778H66.709V50.4216H72.2837V45.9778H74.286Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0923 56.1798C80.2095 55.7034 79.5161 55.0424 79.0136 54.1964C78.5104 53.351 78.2585 52.4053 78.2585 51.3593C78.2585 50.3138 78.5104 49.3681 79.0136 48.5226C79.5161 47.6766 80.2095 47.0156 81.0923 46.5385C81.9752 46.0622 82.9657 45.824 84.0648 45.824C85.1627 45.824 86.1537 46.0622 87.0367 46.5385C87.9196 47.0154 88.6129 47.6743 89.116 48.5144C89.6187 49.3553 89.8706 50.3036 89.8706 51.3592C89.8706 52.4152 89.6187 53.3636 89.116 54.2038C88.6129 55.0449 87.9196 55.7034 87.0367 56.1797C86.1539 56.6566 85.1627 56.8949 84.0648 56.8949C82.9657 56.8949 81.9753 56.6567 81.0923 56.1798ZM86.0049 54.6573C86.58 54.3347 87.0316 53.8837 87.3605 53.3046C87.6889 52.7251 87.8529 52.0767 87.8529 51.3592C87.8529 50.6421 87.6889 49.9936 87.3605 49.4143C87.0316 48.8351 86.58 48.3841 86.0049 48.0609C85.4298 47.7384 84.7829 47.577 84.0648 47.577C83.346 47.577 82.699 47.7384 82.124 48.0609C81.5491 48.3841 81.0974 48.8351 80.7692 49.4143C80.4403 49.9936 80.2763 50.6421 80.2763 51.3592C80.2763 52.0767 80.4403 52.7251 80.7692 53.3046C81.0974 53.8837 81.5491 54.3347 82.124 54.6573C82.6991 54.9806 83.346 55.1419 84.0648 55.1419C84.7829 55.1419 85.4299 54.9806 86.0049 54.6573Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.72 46.4389C101.413 46.7462 101.944 47.187 102.313 47.7611C102.684 48.3355 102.868 49.0168 102.868 49.8062C102.868 50.5855 102.684 51.2645 102.313 51.8436C101.944 52.4231 101.413 52.8662 100.72 53.1736C100.027 53.4811 99.213 53.6353 98.2786 53.6353H95.8455V56.7411H93.8437V45.9777H98.2786C99.213 45.9778 100.027 46.1314 100.72 46.4389ZM100.173 51.3902C100.624 51.0212 100.85 50.4934 100.85 49.8062C100.85 49.1196 100.624 48.5918 100.173 48.2223C99.7213 47.8533 99.059 47.6692 98.1863 47.6692H95.8455V51.9436H98.1863C99.059 51.9434 99.7211 51.7593 100.173 51.3902Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.597 47.6691H105.024V45.9778H114.172V47.6691H110.599V56.7412H108.597V47.6691Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.742 36.2685C78.9513 36.2685 79.1105 36.0753 79.0643 35.8717C77.6588 29.6858 72.1206 25.0671 65.5 25.0671C58.8794 25.0671 53.3412 29.6858 51.9357 35.8717C51.8895 36.0755 52.0487 36.2685 52.258 36.2685H78.742Z",
    fill: "#EF4948"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5963 38.8947H51.4037C51.362 38.8947 51.3282 38.8608 51.3282 38.8192V37.4019C51.3282 37.3603 51.362 37.3264 51.4037 37.3264H79.5964C79.638 37.3264 79.672 37.3603 79.672 37.4019V38.8192C79.672 38.8608 79.638 38.8947 79.5963 38.8947Z",
    fill: "#EF4948"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.338 22.6898H64.6865C64.3881 22.6898 64.1216 22.9077 64.0932 23.2044C64.0608 23.5446 64.3279 23.8308 64.662 23.8308H64.8095C64.9489 23.8308 65.0619 23.9435 65.0619 24.0827V25.3617H65.9381V24.0827C65.9381 23.9435 66.051 23.8308 66.1905 23.8308H66.3084C66.6097 23.8308 66.8811 23.6112 66.9071 23.3114C66.9367 22.9734 66.6705 22.6898 66.338 22.6898Z",
    fill: "#EF4948"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3005_40560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -34,
    width: 131,
    height: 132
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131 -33.6H0V97.2H131V-33.6Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3005_40560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0721 6.70514H58.9279V9.93577H72.0721V6.70514Z",
    fill: "#EF4948"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9279 11.6015V14.6302C58.9279 18.2543 61.8702 21.1923 65.5 21.1923C69.1297 21.1923 72.0721 18.2543 72.0721 14.6302V11.6015H58.9279Z",
    fill: "#EF4948"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3005_40560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandinglogo);
export default __webpack_public_path__ + "static/media/landinglogo.3c0326c501f2bfb03bcbc834972a99f5.svg";
export { ForwardRef as ReactComponent };